export default "__VITE_ASSET__VZSwjl1N__"